import React, { useState, useEffect } from 'react';
import Rodal from 'rodal';
import { Form } from 'informed';
import { InputTypeArea } from '../../../elements';
import { IApplication } from '../types';
import { IFormApi } from '../../types';

type TFormValues = {
  content: string
}

type CreateIssueModalProps = {
  show: boolean,
  application: IApplication,
  onClose: () => void,
  onCreate: (content: string) => void,
}

const CreateIssueModal = ({ show, onClose, onCreate, application }: CreateIssueModalProps) => {
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!show) {
      setSubmitting(false);
    }
  }, [show]);

  const handleCreate = (formApi: IFormApi, values: TFormValues) => {
    if (!values.content || values.content.trim() === '') {
      formApi.setError('content', ['O conteúdo da pendência é obrigatório.']);
      return;
    }

    setSubmitting(true);
    onCreate(values.content);
  }

  return (
    <Rodal
      closeOnEsc
      width={600}
      height={450}
      visible={show}
      onClose={onClose}
    >
      <div className="d-flex flex-column h-100">
        <div className="modal-header">
          <div className="text-center">
            <h2>Nova Pendência</h2>
          </div>
        </div>
        <div className="modal-body">
          <div className="enrollment-flex">
            <Form className="w-100" initialValues={{ content: '' }}>
              {({ formApi, formState }: { formApi: IFormApi, formState: { values: TFormValues } }) => (
                <>
                  <p className="col-md-12">
                    <strong>Inscrição:</strong> #{application.id} - {application.real_name}
                  </p>
                  <InputTypeArea
                    row="8"
                    col="12"
                    label="Conteúdo"
                    field="content"
                    required
                  />
                  <div className="text-right mt-3">
                    <div className="col-md-6 p-0 offset-md-6 col-sm-12">
                      <div className="btn-actions">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={onClose}
                          disabled={submitting}
                        >
                          Cancelar
                        </button>
                        <button
                          className="btn btn-primary ml-2"
                          onClick={() => handleCreate(formApi, formState.values)}
                          disabled={submitting}
                          type="button"
                        >
                          Criar Pendência
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Form>
          </div>
        </div>
      </div>
    </Rodal>
  )
}

export default CreateIssueModal;
